export default "__VITE_ASSET__bdf3c690__"